import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Ul } from "./UlBlock";
import { defaultData } from "./UlBlockDefaultData";
import { meta } from "./UlBlockMetaData";

export const UlBlock: BlockExport = {
  type: "component",
  Block: Ul,
  imagePreview: {
    type: "icon",
    name: "24-list",
    size: 24,
  },
  defaultData,
  meta,
};
